import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useTranslation } from "react-i18next";
import EventsSearchContext from "../../../application/Context/EventsSearchContext";
export var InfoBar = function () {
    var _a = React.useContext(EventsSearchContext), count = _a.count, view = _a.view;
    var t = useTranslation(["news"]).t;
    return (_jsx(_Fragment, { children: view == "list" && (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [count, " ", t("éléments")] }) })) }));
};
